export interface Config {
  serverUrl: string;
}

export const config: Config = {
  serverUrl: 'https://navi.antogin.dev',
}
